import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { InPlaceEditor } from '@syncfusion/ej2-inplace-editor';

import { ScheduleFrequency } from '@/shared/types/schedule';

import { getControl, getEditor, getProps, updateEditor } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="scheduleFrequency"]')]
    .map((editableElement) => editableElement as HTMLDivElement)
    .forEach((editableElement) => {
      const form = editableElement.closest('form') as HTMLFormElement;

      const dropDownList = getControl(editableElement.id) as DropDownList | undefined;

      const editor = getEditor(editableElement.id) as InPlaceEditor | undefined;

      const control = dropDownList ?? editor;

      if (control) {
        const refresh = (scheduleFrequency: ScheduleFrequency, options?: { isDefault?: boolean; save?: boolean }) => {
          const { isDefault, save } = options ?? {};

          const selected = control.value === scheduleFrequency || (control.value === null && isDefault);

          const dayDiv = form.querySelector(
            `div[data-schedule-frequency="${scheduleFrequency}"]`,
          ) as HTMLTableRowElement;

          dayDiv.classList.toggle('d-none', !selected);

          const dayEditable = dayDiv.querySelector('.editable[data-field="scheduleDay"]');

          if (dayEditable) {
            const dayEditableProps = getProps(dayEditable.id);

            const dayDropDownList = getControl(dayEditable.id) as DropDownList | undefined;

            const dayEditor = getEditor(dayEditable.id) as InPlaceEditor | undefined;

            const disabled = !selected || !!dayEditableProps?.readOnly;

            if (dayDropDownList) {
              dayDropDownList.enabled = !disabled;
            } else if (dayEditor) {
              dayEditor.disabled = disabled;

              if (selected && save) {
                updateEditor(dayEditable.id, null);
              }
            }
          }
        };

        refresh(ScheduleFrequency.Days, { isDefault: true });
        refresh(ScheduleFrequency.Weeks);
        refresh(ScheduleFrequency.Months);
        refresh(ScheduleFrequency.Years);

        if (dropDownList) {
          dropDownList.addEventListener('change', () => {
            refresh(ScheduleFrequency.Days, { isDefault: true });
            refresh(ScheduleFrequency.Weeks);
            refresh(ScheduleFrequency.Months);
            refresh(ScheduleFrequency.Years);
          });
        } else if (editor) {
          editor.addEventListener('actionSuccess', () => {
            refresh(ScheduleFrequency.Days, { save: true, isDefault: true });
            refresh(ScheduleFrequency.Weeks, { save: true });
            refresh(ScheduleFrequency.Months, { save: true });
            refresh(ScheduleFrequency.Years, { save: true });
          });
        }
      }
    });
});
